import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './Logo.css';

interface ILogoProps {
  url: string;
  noResize: boolean;
  src: string | null;
  onClick: () => void;
}

const LogoIcon = () => (
  // oxlint-disable-next-line react/forbid-elements
  <svg className={styles['logo-icon']} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 110 40">
    <path
      fill="#0468FF"
      fillRule="evenodd"
      d="M19.5 9.13c-1.547 0-2.8-1.264-2.8-2.824 0-1.56 1.253-2.825 2.8-2.825 1.545 0 2.799 1.265 2.799 2.825 0 1.56-1.254 2.824-2.8 2.824zm0-8.97c-3.373 0-6.107 2.757-6.107 6.16a6.167 6.167 0 001.24 3.72l.406.567 4.46 5.427 4.867-5.995a6.168 6.168 0 001.239-3.72c0-3.402-2.734-6.16-6.106-6.16zM21.83 28.78V18.443h-4.523v4.855l-4.52-5.479L.2 33.075l4.187 3.516 8.4-10.18 8.4 10.18 4.186-3.516-3.543-4.295z"
      clipRule="evenodd"
    />
    <path
      fill="var(--text-primary-default)"
      fillRule="evenodd"
      d="M49.57 18.429h-4.011v14.09H37.63V18.43H33.62v17.833h14.77v3.578h3.634v-7.32H49.57V18.428zM58.84 30.435V18.429h-4.01v17.833h4.01l8.4-12.006v12.006h4.011V18.429h-4.01l-8.4 12.006zM105.813 18.429v7.007h-8.188v-7.007h-4.011v17.833h4.011v-7.058h8.188v7.058h3.987V18.429h-3.987zM85.74 28.732c0 1.4-.393 2.495-1.167 3.256-.784.77-1.922 1.16-3.382 1.16-1.827 0-2.833-.83-2.833-2.339 0-1.573 1.316-2.512 3.519-2.512h3.862v.435zm-3.348-10.644c-2.096 0-3.901.566-5.221 1.637-1.235 1-1.966 2.399-2.065 3.94h3.954c.18-.828 1.057-2.119 3.332-2.119 2.096 0 3.347 1.263 3.347 3.378v.088h-4.034c-2.388 0-4.233.545-5.484 1.62-1.198 1.03-1.805 2.493-1.805 4.35 0 1.601.624 3.038 1.76 4.045 1.162 1.033 2.778 1.579 4.672 1.579 2.966 0 4.58-1.46 5.135-2.086l.275 1.528.038.211h3.386V24.924c0-4.216-2.794-6.836-7.29-6.836z"
      clipRule="evenodd"
    />
  </svg>
);

export const Logo: React.FC<ILogoProps> = ({ noResize, url, src, onClick }) => {
  const isWebM = src?.endsWith('.webm');

  const style = React.useMemo(() => {
    return src && !isWebM ? { backgroundImage: `url('${src}')`, backgroundPosition: 'unset' } : undefined;
  }, [src, isWebM]);

  if (isWebM) {
    return (
      <video
        data-name="Logo"
        className={clsx(styles['container'], noResize && styles['static'], styles['video'])}
        autoPlay
        muted
        loop
        playsInline
        onClick={() => (window.location.href = url)}
      >
        <source src={src || undefined} type="video/webm" />
        <a
          data-name="Logo"
          href={url}
          className={clsx(styles['container'], noResize && styles['static'])}
          style={style}
          onClick={onClick}
        >
          Your browser does not support the video tag.
        </a>
      </video>
    );
  }

  return (
    <a
      data-name="Logo"
      href={url}
      className={clsx(styles['container'], noResize && styles['static'])}
      style={style}
      onClick={onClick}
    >
      {!style?.backgroundImage && <LogoIcon />}
    </a>
  );
};
